import type { ReactNode } from 'react';
import { Icon } from '../Icon/Icon.js';
import { ICONS, ICON_ALIASES, type IconAlias, type IconName } from '../Icon/icons.js';

/* Every icon prop takes an IconName (preferred) or a node. */
export type IconSlot = IconName | IconAlias | ReactNode;

const isIconName = (v: unknown): v is IconName | IconAlias =>
  typeof v === 'string' && (v in ICONS || v in ICON_ALIASES);

export function renderIconSlot(slot: IconSlot, size: number, color?: string, weight?: number): ReactNode {
  if (slot == null || slot === false) return null;
  return isIconName(slot) ? <Icon name={slot} size={size} color={color} weight={weight} disclose={false} /> : slot;
}
